"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isEmptyValue = function (value) { return value === undefined || value === null || value === ''; };
exports.default = isEmptyValue;
//# sourceMappingURL=index.js.map